import { render, staticRenderFns } from "./Warn.vue?vue&type=template&id=9224f54c&scoped=true"
import script from "./Warn.vue?vue&type=script&lang=ts"
export * from "./Warn.vue?vue&type=script&lang=ts"
import style0 from "./Warn.vue?vue&type=style&index=0&id=9224f54c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9224f54c",
  null
  
)

export default component.exports